import { render } from "./OdooIntegrationView.vue?vue&type=template&id=445f9f48&scoped=true"
import script from "./OdooIntegrationView.vue?vue&type=script&lang=js"
export * from "./OdooIntegrationView.vue?vue&type=script&lang=js"

import "./OdooIntegrationView.vue?vue&type=style&index=0&id=445f9f48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-445f9f48"]])

export default __exports__